import { formatDetailLabel } from '@/features/inventorization/detail-field-options';
import { translateFirstInventoryText, translateInventoryText } from '@/shared/i18n/inventory-i18n';

const detailTranslationKeys: Record<string, string> = {
  circuitBreakerSize: 'reservedPower',
  deviceCategory: 'deviceType',
  diameterNominal: 'diameterNominal',
  flange: 'flange',
  flowrate: 'flowRate',
  gSize: 'gSize',
  heatMeasurementType: 'heatMeasurementType',
  inputSpec: 'inputSpecification',
  hotWater: 'hotWater',
  iMax: 'maximumCurrent',
  iMin: 'minimumCurrent',
  iRef: 'referenceCurrent',
  installationPosition: 'installationPosition',
  layLength: 'layLength',
  measurementCategory: 'measurementCategory',
  measurementType: 'measuringType',
  measuringCurrentTransformer: 'MCT',
  mounting: 'mounting',
  orientation: 'orientation',
  pMax: 'pmax',
  phases: 'numberOfPhases',
  qMax: 'qMax',
  qMin: 'qMin',
  resistance: 'resistance',
  secondSerialNumber: 'serialNumber2',
  tariffs: 'tariffs',
  tubeMaterial: 'tubeMaterial',
  width: 'width',
  woltman: 'woltman',
};

export function fieldWizardText(fieldId: string, part: 'description' | 'placeholder', fallback: string) {
  return translateInventoryText(`app.inventory.fieldWizard.${fieldId}.${part}`, fallback);
}

export function detailWizardLabel(detailKey: string) {
  return translateFirstInventoryText(createDetailTranslationKeys(detailKey, ''), formatDetailLabel(detailKey));
}

export function detailWizardDescription(detailKey: string) {
  const label = detailWizardLabel(detailKey).toLowerCase();

  return translateFirstInventoryText(
    createDetailTranslationKeys(detailKey, 'Tooltip'),
    translateInventoryText('app.inventory.fieldWizard.detail.description', 'Confirm {label}.', { label }),
  );
}

export function detailWizardPlaceholder(detailKey: string, fallback: string) {
  return translateFirstInventoryText(createDetailTranslationKeys(detailKey, 'Placeholder'), fallback);
}

function createDetailTranslationKeys(detailKey: string, suffix: '' | 'Placeholder' | 'Tooltip') {
  const translatedKey = detailTranslationKeys[detailKey];
  const keys = [`app.inventory.fieldWizard.detail.${detailKey}${suffix}`];

  if (translatedKey) {
    keys.push(`app.common.meterDetails.${translatedKey}${suffix}`);
  }

  return keys;
}
